import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FeedbackWebService } from '../../../services/general/feedback.service';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  standalone: true,
  selector: 'rs-web-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  imports: [NgbToast, NgTemplateOutlet],
  host: {
    class: 'toast-container',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastsContainerComponent {
  public feedbackService = inject(FeedbackWebService);
}
